export default __webpack_public_path__ + "static/media/seema-h-logo-modified.fa17df4e.png";